import { render, staticRenderFns } from "./NewErrorModal.vue?vue&type=template&id=1048d4d0&"
import script from "./NewErrorModal.vue?vue&type=script&lang=ts&"
export * from "./NewErrorModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports